<template>
  <div class="tableData">
    <div class="assetFieldDiv">
      <div class="basicParameters">
        <div class="titleDiv">
          <div class="title">
            <span>设备基础信息字段</span>
            <a-button class="checkAll" type="primary" @click="whetherToSelectAll(true)">全选</a-button>
            <a-button class="deselectAll" @click="whetherToSelectAll(false)">取消全选</a-button>
            <a-popconfirm
              cancel-text="取消"
              ok-text="确定"
              title="初始化后，该设备类型对应的字段配置将被清空，确定是否继续？"
              @confirm="restoreInitialization()"
            >
              <a-button :loading="saveLoading" class="deselectAll" v-show="!noPermission">恢复初始化</a-button>
            </a-popconfirm>
          </div>
          <a-button :loading="saveLoading" type="primary" @click="save" v-show="!noPermission">保存</a-button>
        </div>
        <span v-if="noPermission" class="noPermissionDiv">该设备类型您无权限配置</span>
        <a-spin v-else :spinning="treeLoading">
          <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange"/>
        </a-spin>
      </div>
      <div class="otherParameters2" v-show="!noPermission">
        <div class="titleDiv">
          <div class="title">
            <span>参数特性字段</span>
          </div>
        </div>
        <div class="other-data">
          <a-row :gutter="10" class="item-label">
            <a-col :span="8" class="fontWeight">类型</a-col>
            <a-col :span="8" class="fontWeight">参数/特性</a-col>
            <a-col :span="8" class="fontWeight">字段</a-col>
          </a-row>
          <div class="dataInputDiv">
            <a-row v-for="(item, index) in parameterCharacteristicsList" :key="index" :gutter="10" class="item-data">
              <a-col :span="8">
                <a-select v-model="item.type" placeholder="请输入类型" style="width: 100%" @change="changeType(item, index)">
                  <a-select-option v-for="(item2, index2) in typeList" :key="index2" :value="item2.value">
                    {{ item2.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="8">
                <!--                基础参数-->
                <a-select v-model="item.paramOrFeature" placeholder="请选择参数/特性" style="width: 100%" @change="value => changeFeature(value, item, index)" v-if="item.type === 2">
                  <a-select-option v-for="(item2, index2) in fieldListData.paramList" :key="index2" :value="index2">
                    {{ item2.typeName }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select style="width: 100%" v-else-if="item.type === 3" disabled>
                </a-select>
                <!--                特性-->
                <a-select v-model="item.paramOrFeature" placeholder="请选择参数/特性" style="width: 100%" v-else-if="item.type === 4" @change="value => changeParamOrFeature(value,item)">
                  <a-select-option v-for="(item2, index2) in fieldListData.peculiarityList" :key="index2" :value="item2.id">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                默认-->
                <a-select style="width: 100%" v-else disabled>
                </a-select>
              </a-col>
              <a-col :span="8">
                <!--                基础参数-->
                <a-select v-model="item.field" placeholder="请选择字段" style="width: 100%" v-if="item.type === 2" @change="value => changeField(value,item)">
                  <a-select-option v-for="(item2, index2) in item.fieldList" :key="index2" :value="item2.fieldId">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select v-model="item.field" placeholder="请选择字段" style="width: 100%" v-else-if="item.type === 3">
                  <a-select-option v-for="(item2, index2) in fieldListData.typeParamList" :key="index2" :value="item2.id">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select v-model="item.field" style="width: 100%" v-else disabled>
                </a-select>
                <a-icon type="close-square" @click="del_other(item, index)" class="delIcon"/>
              </a-col>
            </a-row>
          </div>
        </div>
        <a-button block type="dashed" icon="plus" @click="add_other" class="addBtn_general">添加</a-button>
      </div>
    </div>
    <div class="treeListDiv">
      <div class="titleDiv">
        <div class="title">
          <span>已选字段</span>
        </div>
      </div>
      <a-spin :spinning="treeLoading">
        <a-tree
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          :draggable="!noPermission"
          @dragstart="onStart"
          @drop="onDrop"
        >
          <template slot="custom" slot-scope="item">
            <span>{{ item.title }}</span>
          </template>
        </a-tree>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { getAssetField, getAssetTypeField, saveAssetTypeField } from '@/api/assetHeadManage'
import { getTypeFieldByTypeCode, getBaseField, getTypeFieldDataByTypeId, saveTypeField } from '@/api/deviceType'
import { mapGetters } from 'vuex'

export default {
  name: 'TableData',
  computed: {
    ...mapGetters(['equipmentHeadTypeCode'])
  },
  data () {
    return {
      // 树
      treeData: [],
      // 树搜索
      searchValue: '',
      // 树当前选中节点
      selectedKeys: [],
      // 树loading
      treeLoading: false,
      // 多选列表
      plainOptions: [],
      // 多选
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      // 保存loading
      saveLoading: false,
      // 无权限页面
      noPermission: false,
      // 改变过的类型
      changeHeadList: [],
      // 已选择字段/常规参数可选字段/特性可选字段
      fieldListData: [],
      parameterCharacteristicsList: [],
      parameterCharacteristicsListOriginal: [],
      typeList: [
        {
          label: '基础参数',
          value: 2
        },
        {
          label: '特性',
          value: 4
        }
      ]
    }
  },
  created () {
    this.getBaseField()
  },
  mounted () {
  },
  watch: {
    equipmentHeadTypeCode (newValue) {
      console.log(newValue)
      if (newValue.equipmentType === '无权限') {
        this.noPermission = true
        this.treeData = []
      } else {
        this.noPermission = false
        this.getTreeList()
      }
    }
  },
  methods: {
    // 获取树形菜单
    async getTreeList () {
      this.treeLoading = true
      // 获取自定义字段中的数据
      const data2 = {
        typeId: this.equipmentHeadTypeCode.equipmentId,
        type: 2
      }
      await getTypeFieldDataByTypeId(data2).then(res => {
        if (res.status === 0) {
          this.fieldListData = res.data
          const data = []
          res.data.fieldList.forEach(item => {
            if (item.type === 2) {
              // 基础参数
              const index = this.fieldListData.paramList.findIndex(item2 => item2.typeName === item.pName)
              const params = {
                field: Number(item.dataIndex),
                fieldList: index > -1 ? this.fieldListData.paramList[index].children : [],
                paramOrFeature: index,
                type: item.type
              }
              data.push(params)
            } else if (item.type === 3) {
              //  自定义参数
              const params = {
                field: Number(item.dataIndex),
                type: item.type
              }
              data.push(params)
            } else if (item.type === 4) {
              //  特性参数
              const params = {
                paramOrFeature: Number(item.dataIndex),
                type: item.type
              }
              data.push(params)
            }
          })
          this.parameterCharacteristicsList = JSON.parse(JSON.stringify(data))
          this.parameterCharacteristicsListOriginal = JSON.parse(JSON.stringify(data))
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      // 获取选中的字段
      this.checkedList = []
      const query = {
        typeCode: this.equipmentHeadTypeCode.equipmentType,
        type: 2
      }
      await getTypeFieldByTypeCode(query).then(res => {
        if (res.status === 0) {
          this.treeData = []
          res.data.forEach((item, index) => {
            const data = {
              scopedSlots: { title: 'custom' },
              key: index,
              dataIndex: item.field,
              type: item.type,
              title: item.title,
              pcode: item.pcode
              // ...item
            }
            if (item.type === 1) {
              this.checkedList.push(item.dataIndex)
            }
            this.treeData.push(data)
          })
          this.indeterminate = !!this.checkedList.length && this.checkedList.length < this.plainOptions.length
          this.checkAll = this.checkedList.length === this.plainOptions.length
          this.treeLoading = false
        } else {
          this.$message.error(res.info.message)
          this.treeLoading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.treeLoading = false
      })
    },
    // 获取所有字段
    getBaseField () {
      const data = {
        pCode: 'equipment_field'
      }
      this.spinLoading = true
      getBaseField(data).then(res => {
        if (res.status === 0) {
          this.plainOptions = res.data.map(item => {
            return {
              label: item.name,
              value: item.code
            }
          })
          this.spinLoading = false
        } else {
          this.$message.error(res.info.message)
          this.spinLoading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.spinLoading = false
      })
    },
    // 多选回调
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    // 是否全选
    whetherToSelectAll (bool) {
      Object.assign(this, {
        checkedList: bool ? this.plainOptions.map(item => { return item.value }) : []
      })
    },
    // 恢复初始化
    restoreInitialization () {
      this.checkedList = []
      this.parameterCharacteristicsList = []
      this.parameterCharacteristicsListOriginal = []
      this.save()
    },
    // 改变类型
    changeType (item, index) {
      item.paramOrFeature = undefined
      item.field = undefined
      item.fieldList = []
      this.parameterCharacteristicsListOriginal[index] = JSON.parse(JSON.stringify(item))
    },
    // 参数/特性改变
    changeFeature (value, item, index) {
      item.field = undefined
      item.fieldList = this.fieldListData.paramList[value].children
      this.parameterCharacteristicsListOriginal[index] = JSON.parse(JSON.stringify(item))
    },
    // 特性选择(用于判断当前列表中是否有该特性，有则不可选择，并且提示该字段已选择，请选择其他字段)
    changeParamOrFeature (value, item) {
      this.parameterCharacteristicsListOriginal.find((i, index) => {
        if (i.type === 4) {
          if (i.paramOrFeature === value) {
            this.$message.error('该字段已选择，请选择其他字段')
            item.paramOrFeature = undefined
          } else {
            i.paramOrFeature = this.parameterCharacteristicsList[index].paramOrFeature
          }
        }
      })
    },
    // 基础参数选择
    changeField (value, item) {
      this.parameterCharacteristicsListOriginal.find((i, index) => {
        if (i.type === 2) {
          if (i.field === value) {
            this.$message.error('该字段已选择，请选择其他字段')
            item.field = undefined
          } else {
            i.field = this.parameterCharacteristicsList[index].field
          }
        }
      })
    },
    // 判断删除其他参数
    del_other (item, index) {
      this.parameterCharacteristicsList.splice(index, 1)
      this.parameterCharacteristicsListOriginal.splice(index, 1)
    },
    // 增加其他参数
    add_other () {
      this.parameterCharacteristicsList.push({
        type: undefined,
        paramOrFeature: undefined,
        field: undefined
      })
      this.parameterCharacteristicsListOriginal.push({
        type: undefined,
        paramOrFeature: undefined,
        field: undefined
      })
      const div = document.getElementsByClassName('assetFieldDiv')[0]
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
    },
    // 拖拽
    onDrop (info) {
      let realPos
      const that = this
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.treeData]
      const dragPos = info.dragNode.pos.split('-')
      // 判断是否在同一个父节点下移动
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
      })
      if (info.dropToGap) {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
        } else {
          ar.splice(i + 1, 0, dragObj)
        }
        let showTitle = ''
        showTitle = `您确定调整【${info.dragNode.dataRef.title}】的顺序为第【${realPos}】位吗?`
        this.$confirm({
          title: showTitle,
          onOk () {
            // this.treeData = data
            that.drop(data)
          },
          onCancel () {}
        })
      }
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
      this.dragId = info.node.dataRef.id
    },
    // 菜单拖拽
    async drop (data) {
      const params = {
        code: this.equipmentHeadTypeCode.equipmentType,
        typeFieldList: data,
        type: 2
      }
      this.saveLoading = true
      saveTypeField(params).then(res => {
        if (res.status === 0) {
          this.$message.success('操作成功!')
          this.getTreeList()
          this.saveLoading = false
        } else {
          this.$message.error(res.info.message)
          this.saveLoading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.saveLoading = false
      })
    },
    // 保存设置
    save () {
      const typeFieldList = []
      this.checkedList.forEach(item => {
        const data = {
          dataIndex: item,
          type: 1
        }
        typeFieldList.push(data)
      })
      try {
        this.parameterCharacteristicsList.forEach(item => {
          if (item.type) {
            if (item.type === 2) {
              if (item.field) {
                // 基础参数
                const data = {
                  dataIndex: item.field,
                  type: 2,
                  pcode: this.fieldListData.paramList[item.paramOrFeature].typeCode
                }
                typeFieldList.push(data)
              } else {
                throw new Error('请填写完整参数特性字段')
              }
            } else if (item.type === 4) {
              if (item.paramOrFeature) {
                // 特性
                const data = {
                  dataIndex: item.paramOrFeature,
                  type: 4
                }
                typeFieldList.push(data)
              } else {
                throw new Error('请填写完整参数特性字段')
              }
            }
          } else {
            throw new Error('请填写完整参数特性字段')
          }
        })
      } catch (error) {
        this.$message.error('请填写完整参数特性字段')
        this.btnLoading = false
        return
      }
      const data = {
        code: this.equipmentHeadTypeCode.equipmentType,
        typeFieldList: typeFieldList,
        type: 2
      }
      this.saveLoading = true
      saveTypeField(data).then(res => {
        if (res.status === 0) {
          this.changeHeadList.push(this.equipmentHeadTypeCode.equipmentType)
          this.saveLoading = false
          this.getTreeList()
          this.$emit('setChangeHeadList', this.changeHeadList)
          this.$message.success(res.info.message)
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tableData {
  height: 100%;
  width: 100%;
  display: flex;
}
.treeListDiv {
  width: 300px;
  height: 100%;
  padding: 16px 12px;
}
.assetFieldDiv {
  width: calc(100% - 300px);
  padding: 8px 12px;
  border-right: 1px solid #DDDDDD;
  position: relative;
  .noPermissionDiv {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 44px;
    margin: auto;
    width: 250px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    height: 30px;
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    font-weight: bold;
  }
  .checkAll {
    margin-left: 20px;
  }
  .deselectAll {
    margin-left: 8px;
  }
}
.other-data{
  position: relative;
  height: calc(100% - 44px);
  .action-btn{
    position: absolute;
    right: 10px;
    top: -36px;
    display: flex;
    .btn{
      margin-left: 10px;
    }
  }
  .item-label{
    margin: 0 0 12px 0 !important;
    background: #F5F5F5;
    .ant-col {
      padding: 10px 8px;
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      border-right: 1px solid #DDDDDD;
    }
    .ant-col:nth-child(1) {
      border-left: 1px solid #DDDDDD;
    }
    .anticon{
      color: #1791FF;
      font-size: 14px;
      margin-left: 9px;
      margin-right: 9px;
    }
    .anticonTooltip{
      color: #1791FF;
      font-size: 12px;
    }
  }
  .dataInputDiv {
    height: calc(100% - 70px);
    /deep/.ant-col {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .delIcon {
      margin-left: 12px;
    }
  }
  .item-data{
    width: 100%;
    margin-bottom: 12px;
    .anticon{
      color: #E73B3B;
      font-size: 20px;
    }
  }
}
.fontWeight {
  font-weight: bold;
}
/deep/ .ant-spin-nested-loading {
  height: calc(100% - 40px);
  .ant-spin-container {
    height: 100%;
    .ant-tree {
      height: 100%;
      overflow-y: auto;
    }
  }
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
  width: calc(100% - 24px);
  height: 100%;
}
/deep/.ant-tree li .ant-tree-node-content-wrapper .ant-tree-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
/deep/.ant-checkbox-group-item {
  width: calc(100% / 4);
  margin: 0 0 10px 0 !important;
}
</style>
